import Navbar from "../component/navbar";
import BottomBar from "../component/bottomBar";
import {
  Home,
  TrendingUp,
  Briefcase,
  CheckCircle,
  ArrowRight,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <>
      <Navbar />
      <div className="bg-white">
        {/* ===== HERO SECTION ===== */}
        <div className="min-h-screen bg-gradient-to-r from-blue-50 via-white to-blue-50 flex items-center pt-10 pb-10">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto text-center">
              {/* Badge */}
              <div className="inline-block bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-8">
                ✓ RERA Verified • 100% Transparent • Tricity's #1 Platform
              </div>

              {/* Main Heading */}
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-8 leading-tight">
                Find Your Perfect Property
              </h1>

              {/* Subheading */}
              <p className="text-lg md:text-xl text-gray-600 mb-12 leading-relaxed">
                Verified properties, trusted dealers, and real deals for Buyers,
                Sellers, and Investors across Mohali, Chandigarh & Panchkula
              </p>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
                <button
                  onClick={() => navigate("/property")}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold flex items-center justify-center gap-2 transition-all transform hover:scale-105 shadow-md hover:shadow-lg"
                >
                  Search Properties
                  <ArrowRight size={20} />
                </button>
                <button
                  onClick={() => navigate("/property")}
                  className="border-2 border-blue-600 text-blue-600 hover:bg-blue-50 px-8 py-4 rounded-lg font-semibold transition-all shadow-md hover:shadow-lg"
                >
                  List Your Property
                </button>
              </div>

              {/* Stats */}
              <div className="flex flex-col sm:flex-row justify-center gap-8 sm:gap-12 pt-12 border-t border-gray-200">
                <div className="py-6">
                  <p className="text-3xl md:text-4xl font-bold text-gray-900">
                    1000+
                  </p>
                  <p className="text-gray-600 text-sm font-medium mt-2">
                    Properties Listed
                  </p>
                </div>
                <div className="py-6">
                  <p className="text-3xl md:text-4xl font-bold text-gray-900">
                    500+
                  </p>
                  <p className="text-gray-600 text-sm font-medium mt-2">
                    Happy Customers
                  </p>
                </div>
                <div className="py-6">
                  <p className="text-3xl md:text-4xl font-bold text-gray-900">
                    50+
                  </p>
                  <p className="text-gray-600 text-sm font-medium mt-2">
                    Verified Dealers
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ===== WHO IS IT FOR SECTION ===== */}
        <div className="py-28 bg-gray-50">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-20">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                For Everyone
              </h2>
              <p className="text-gray-600 text-lg max-w-2xl mx-auto leading-relaxed">
                Whether you're buying, selling, investing, or growing a business
                - we've got you covered
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {/* Card 1 - Buyers */}
              <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                  <Home className="text-blue-600" size={28} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">Buyers</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Browse verified properties with real photos, transparent
                  pricing, and no hidden costs.
                </p>
              </div>

              {/* Card 2 - Sellers */}
              <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100">
                <div className="w-14 h-14 bg-green-100 rounded-lg flex items-center justify-center mb-6">
                  <TrendingUp className="text-green-600" size={28} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  Sellers
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  List your property and reach serious buyers instantly. Zero
                  brokerage confusion.
                </p>
              </div>

              {/* Card 3 - Investors */}
              <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100">
                <div className="w-14 h-14 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                  <TrendingUp className="text-purple-600" size={28} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  Investors
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Discover RERA projects, analyze returns, and make data-driven
                  investment decisions.
                </p>
              </div>

              {/* Card 4 - Agents */}
              <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-6">
                  <Briefcase className="text-orange-600" size={28} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">Agents</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Manage leads, close deals faster, and grow your real estate
                  business with our CRM.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ===== HOW IT WORKS SECTION ===== */}
        <div className="py-28 bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-20">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Simple Process
              </h2>
              <p className="text-gray-600 text-lg">
                Just 4 steps to find your dream property
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-8">
              {/* Step 1 */}
              <div className="flex flex-col items-center">
                <div className="w-20 h-20 bg-blue-600 text-white rounded-full flex items-center justify-center text-3xl font-bold mb-6 shadow-lg">
                  1
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-4 text-center">
                  Search
                </h3>
                <p className="text-gray-600 text-sm text-center leading-relaxed">
                  Browse verified properties by location, budget & preference
                </p>
              </div>

              {/* Step 2 */}
              <div className="flex flex-col items-center">
                <div className="w-20 h-20 bg-blue-600 text-white rounded-full flex items-center justify-center text-3xl font-bold mb-6 shadow-lg">
                  2
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-4 text-center">
                  Connect
                </h3>
                <p className="text-gray-600 text-sm text-center leading-relaxed">
                  Chat directly with verified agents or property owners
                </p>
              </div>

              {/* Step 3 */}
              <div className="flex flex-col items-center">
                <div className="w-20 h-20 bg-blue-600 text-white rounded-full flex items-center justify-center text-3xl font-bold mb-6 shadow-lg">
                  3
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-4 text-center">
                  Visit
                </h3>
                <p className="text-gray-600 text-sm text-center leading-relaxed">
                  Schedule site visits and inspect properties with confidence
                </p>
              </div>

              {/* Step 4 */}
              <div className="flex flex-col items-center">
                <div className="w-20 h-20 bg-green-600 text-white rounded-full flex items-center justify-center text-3xl font-bold mb-6 shadow-lg">
                  ✓
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-4 text-center">
                  Deal
                </h3>
                <p className="text-gray-600 text-sm text-center leading-relaxed">
                  Close the deal with transparency and support
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ===== TRUST & FEATURES SECTION ===== */}
        <div className="py-28 bg-blue-50">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-16 text-center">
                Why Trust Us?
              </h2>

              <div className="space-y-4">
                {[
                  "RERA Verified Projects & Agents",
                  "Verified Dealer Profiles",
                  "Transparent Pricing - No Hidden Costs",
                  "Secure Transactions & Data Privacy",
                  "Local Market Expertise",
                  "Free Customer Support",
                ].map((item, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-4 bg-white p-5 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all"
                  >
                    <CheckCircle
                      className="text-green-600 flex-shrink-0"
                      size={26}
                    />
                    <p className="text-gray-700 font-medium text-lg">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* ===== PRICING SECTION - 4 PLANS IN ONE ROW ===== */}
        <div className="py-28 bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-20">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Choose Your Plan
              </h2>
              <p className="text-gray-600 text-lg">
                Start free and upgrade anytime
              </p>
            </div>

            {/* 4 PLANS IN ONE ROW */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
              {/* PLAN 1 - FREE */}
              <div className="border-2 border-gray-300 rounded-xl p-8 hover:shadow-xl transition-all duration-300 bg-white">
                <div className="inline-block bg-gray-300 text-gray-700 px-3 py-1 rounded-full text-xs font-bold mb-6">
                  FREE
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Free Plan
                </h3>
                <div className="mb-6">
                  <div className="text-4xl font-bold text-gray-900">₹0</div>
                  <div className="text-gray-600 text-sm font-semibold mt-1">
                    Forever Free
                  </div>
                </div>
                <p className="text-gray-700 font-semibold mb-6 text-sm">
                  For Individuals (Self-Use)
                </p>
                <ul className="space-y-3 mb-10 text-xs text-gray-700">
                  <li className="flex items-center gap-2">
                    <span className="text-green-600 font-bold">✅</span>
                    <span>List 1 property</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-green-600 font-bold">✅</span>
                    <span>Single-user access</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-red-600 font-bold">❌</span>
                    <span>Basic portal visibility</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-red-600 font-bold">❌</span>
                    <span>Limited buyer enquiries</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-red-600 font-bold">❌</span>
                    <span>No boosting / No CRM</span>
                  </li>
                </ul>
                <a
                  href="https://wa.me/919999999999?text=Hi,%20I%20want%20Free%20Plan%20details."
                  className="w-full block text-center bg-gray-600 hover:bg-gray-700 text-white py-3 rounded-lg font-semibold transition-all text-sm"
                >
                  Start Free
                </a>
              </div>

              {/* PLAN 2 - ₹499 */}
              <div className="border-2 border-blue-400 rounded-xl p-8 hover:shadow-xl transition-all duration-300 bg-blue-50">
                <div className="inline-block bg-blue-400 text-white px-3 py-1 rounded-full text-xs font-bold mb-6">
                  STARTER
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Basic Plan
                </h3>
                <div className="mb-6">
                  <div className="text-4xl font-bold text-gray-900">₹499</div>
                  <div className="text-gray-600 text-sm font-semibold mt-1">
                    / month
                  </div>
                </div>
                <p className="text-gray-700 font-semibold mb-6 text-sm">
                  For Local Dealers
                </p>
                <ul className="space-y-3 mb-10 text-xs text-gray-700">
                  <li className="flex items-center gap-2">
                    <span className="text-green-600 font-bold">✅</span>
                    <span>Up to 5 properties</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-green-600 font-bold">✅</span>
                    <span>Single-user access</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-green-600 font-bold">✅</span>
                    <span>Basic property visibility</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-green-600 font-bold">✅</span>
                    <span>Buyer messages & chat</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-red-600 font-bold">❌</span>
                    <span>No boosting / No CRM</span>
                  </li>
                </ul>
                <a
                  href="https://wa.me/919999999999?text=Hi,%20I%20want%20Basic%20Plan%20details."
                  className="w-full block text-center bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-semibold transition-all text-sm"
                >
                  Book Demo
                </a>
              </div>

              {/* PLAN 3 - ₹999 - MOST POPULAR */}
              <div className="border-4 border-blue-600 rounded-xl p-8 shadow-2xl bg-gradient-to-br from-blue-50 to-white relative transform lg:scale-105">
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 py-2 rounded-full text-xs font-bold shadow-lg">
                  ⭐ MOST POPULAR
                </div>
                <div className="inline-block bg-gradient-to-r from-blue-600 to-blue-700 text-white px-3 py-1 rounded-full text-xs font-bold mb-6 mt-4">
                  GROWTH
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Growth Plan
                </h3>
                <div className="mb-6">
                  <div className="text-4xl font-bold text-gray-900">₹999</div>
                  <div className="text-gray-600 text-sm font-semibold mt-1">
                    / month
                  </div>
                </div>
                <p className="text-gray-700 font-semibold mb-6 text-sm">
                  For Active Local Dealers
                </p>
                <ul className="space-y-3 mb-10 text-xs text-gray-700">
                  <li className="flex items-center gap-2">
                    <span className="text-green-600 font-bold">✅</span>
                    <span>Up to 20 properties/month</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-green-600 font-bold">✅</span>
                    <span>Multi-agent access</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-green-600 font-bold">✅</span>
                    <span>Higher listing visibility</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-green-600 font-bold">✅</span>
                    <span>Weekly booster feature</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-green-600 font-bold">✅</span>
                    <span>Basic CRM tools</span>
                  </li>
                </ul>
                <a
                  href="https://wa.me/919999999999?text=Hi,%20I%20want%20Growth%20Plan%20demo."
                  className="w-full block text-center bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-3 rounded-lg font-semibold transition-all text-sm"
                >
                  Book Growth Demo
                </a>
              </div>

              {/* PLAN 4 - ₹1,999 */}
              <div className="border-2 border-orange-400 rounded-xl p-8 hover:shadow-xl transition-all duration-300 bg-orange-50">
                <div className="inline-block bg-orange-400 text-white px-3 py-1 rounded-full text-xs font-bold mb-6">
                  PRO
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Pro Plan
                </h3>
                <div className="mb-6">
                  <div className="text-4xl font-bold text-gray-900">₹1,999</div>
                  <div className="text-gray-600 text-sm font-semibold mt-1">
                    / month
                  </div>
                </div>
                <p className="text-gray-700 font-semibold mb-6 text-sm">
                  For Large Networks & Builders
                </p>
                <ul className="space-y-3 mb-10 text-xs text-gray-700">
                  <li className="flex items-center gap-2">
                    <span className="text-green-600 font-bold">✅</span>
                    <span>Unlimited listings</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-green-600 font-bold">✅</span>
                    <span>Unlimited users</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-green-600 font-bold">✅</span>
                    <span>Maximum visibility & boosts</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-green-600 font-bold">✅</span>
                    <span>Advanced CRM & analytics</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="text-green-600 font-bold">✅</span>
                    <span>Dedicated support</span>
                  </li>
                </ul>
                <a
                  href="https://wa.me/919999999999?text=Hi,%20I%20want%20Pro%20Plan%20details."
                  className="w-full block text-center bg-orange-600 hover:bg-orange-700 text-white py-3 rounded-lg font-semibold transition-all text-sm"
                >
                  Book Pro Demo
                </a>
              </div>
            </div>

          </div>
        </div>

        {/* ===== FOOTER ===== */}
        <footer className="py-2 border-t border-gray-200 text-center text-gray-600 text-sm bg-gray-50">
          <p className="font-medium">
            © 2026 BestPropertiesMohali.com • RERA Verified • Trusted Real
            Estate Marketplace for Tricity
          </p>
        </footer>

        <BottomBar />
      </div>
    </>
  );
}
